const GenerationLimitsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_507_8650)">
        <path
          d="M10 5L13.3333 10L17.5 6.66667L15.8333 15H4.16667L2.5 6.66667L6.66667 10L10 5Z"
          stroke="black"
          strokeOpacity="0.6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_507_8650">
          <rect width="20" height="20" fill="black" />
        </clipPath>
      </defs>
    </svg>
  );
};

const AiCreditsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="black"
      strokeOpacity="0.6"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="c-kqncWw"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z"></path>
    </svg>
  );
};

const ExpressClonesIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8337 2.50193C10.4419 2.5 10.0259 2.5 9.58366 2.5C5.85171 2.5 3.98573 2.5 2.82636 3.65937C1.66699 4.81874 1.66699 6.68472 1.66699 10.4167C1.66699 14.1486 1.66699 16.0146 2.82636 17.174C3.98573 18.3333 5.85171 18.3333 9.58366 18.3333C13.3156 18.3333 15.1816 18.3333 16.341 17.174C17.5003 16.0146 17.5003 14.1486 17.5003 10.4167C17.5003 9.97442 17.5003 9.55842 17.4984 9.16667"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M15.4167 1.66675L15.6316 2.24761C15.9134 3.00926 16.0543 3.3901 16.3322 3.66791C16.61 3.94572 16.9908 4.08664 17.7525 4.36848L18.3333 4.58341L17.7525 4.79835C16.9908 5.08019 16.61 5.22111 16.3322 5.49892C16.0543 5.77673 15.9134 6.15756 15.6316 6.91922L15.4167 7.50008L15.2017 6.91922C14.9199 6.15756 14.779 5.77673 14.5012 5.49892C14.2233 5.22111 13.8425 5.08019 13.0808 4.79835L12.5 4.58341L13.0808 4.36848C13.8425 4.08664 14.2233 3.94572 14.5012 3.66791C14.779 3.3901 14.9199 3.00926 15.2017 2.24761L15.4167 1.66675Z"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M5.83301 14.5833C7.77609 12.5482 11.369 12.4523 13.333 14.5833M11.6623 8.33333C11.6623 9.48392 10.7282 10.4167 9.57592 10.4167C8.42376 10.4167 7.48965 9.48392 7.48965 8.33333C7.48965 7.18274 8.42376 6.25 9.57592 6.25C10.7282 6.25 11.6623 7.18274 11.6623 8.33333Z"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

const DeepClonesIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4991 2.1844C14.1715 1.79425 14.5078 1.59918 14.8373 1.6879C15.1668 1.77663 15.3609 2.11451 15.7491 2.79027L16.9844 4.94051C17.3727 5.61627 17.5668 5.95415 17.4784 6.28529C17.3902 6.61642 17.0539 6.8115 16.3815 7.20165L13.5287 8.85691C12.8563 9.24708 12.5201 9.44216 12.1906 9.35341C11.8611 9.26466 11.6669 8.92683 11.2788 8.25104L10.0434 6.10079C9.65519 5.42503 9.46111 5.08715 9.54936 4.75602C9.63769 4.42489 9.97386 4.22981 10.6463 3.83966L13.4991 2.1844Z"
        stroke="#A6A6A6"
        strokeWidth="1.25"
      />
      <path
        d="M9.63192 5.38403L11.6908 8.96783L8.838 10.6231C8.16555 11.0132 7.82934 11.2082 7.49984 11.1196C7.17034 11.0308 6.97622 10.6929 6.588 10.0172L6.17623 9.30041C5.78801 8.62466 5.5939 8.28679 5.68218 7.95566C5.77047 7.62452 6.10668 7.42945 6.77911 7.0393L9.63192 5.38403Z"
        stroke="#A6A6A6"
        strokeWidth="1.25"
      />
      <path
        d="M5.76462 8.58362L6.99994 10.7339L4.5037 12.1822C4.17138 12.375 4.00522 12.4715 3.84282 12.493C3.62627 12.5216 3.40726 12.4626 3.23397 12.329C3.10401 12.2288 3.00808 12.0618 2.81622 11.7279C2.62436 11.3939 2.52843 11.2269 2.50705 11.0637C2.47854 10.846 2.53722 10.626 2.67018 10.4518C2.76991 10.3212 2.93607 10.2248 3.26838 10.032L5.76462 8.58362Z"
        stroke="#A6A6A6"
        strokeWidth="1.25"
      />
      <path
        d="M6.25 18.3333L10 10L13.75 18.3333"
        stroke="#A6A6A6"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ExportsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_507_8688)">
        <path
          d="M5.5488 15.0002C3.40547 15.0002 1.66797 13.3277 1.66797 11.2644C1.66797 9.2019 3.40547 7.5294 5.5488 7.5294C5.8763 6.06106 7.0438 4.86273 8.6113 4.38523C10.178 3.90856 11.908 4.2244 13.148 5.21856C14.388 6.21023 14.9496 7.7244 14.623 9.19273H15.448C17.0421 9.19273 18.3346 10.4927 18.3346 12.0977C18.3346 13.7036 17.0421 15.0036 15.4471 15.0036H5.5488"
          stroke="black"
          strokeOpacity="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_507_8688">
          <rect width="20" height="20" fill="black" />
        </clipPath>
      </defs>
    </svg>
  );
};

const AdditionalFeaturesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      className="c-kqncWw"
    >
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M16 12.5C16 12.5 13.0541 16.5 12 16.5C10.9459 16.5 8.00003 12.5 8.00003 12.5M12 16V7.5"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

const GenerativeClipsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      opacity="0.6"
      color="black"
      fill="none"
    >
      <path
        d="M18.5 2L18.7579 2.69703C19.0961 3.61102 19.2652 4.06802 19.5986 4.40139C19.932 4.73477 20.389 4.90387 21.303 5.24208L22 5.5L21.303 5.75792C20.389 6.09613 19.932 6.26524 19.5986 6.59861C19.2652 6.93198 19.0961 7.38898 18.7579 8.30297L18.5 9L18.2421 8.30297C17.9039 7.38898 17.7348 6.93198 17.4014 6.59861C17.068 6.26524 16.611 6.09613 15.697 5.75792L15 5.5L15.697 5.24208C16.611 4.90387 17.068 4.73477 17.4014 4.40139C17.7348 4.06802 17.9039 3.61102 18.2421 2.69703L18.5 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 3H4C2.89543 3 2 3.89543 2 5V20C2 21.1046 2.89543 22 4 22H19C20.1046 22 21 21.1046 21 20V11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 14.4583V10.542C9 9.76849 9.81435 9.26542 10.5065 9.61133L14.4246 11.5695C15.1918 11.9529 15.1918 13.0473 14.4246 13.4308L10.5065 15.3889C9.81435 15.7349 9 15.2318 9 14.4583Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ContentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      opacity="0.6"
      color="black"
      fill="none"
    >
      <path
        d="M10.4694 6.02506C10.4762 5.99165 10.5239 5.99165 10.5308 6.02506C10.8853 7.75942 12.2406 9.11481 13.975 9.4693C14.0084 9.47613 14.0084 9.52387 13.975 9.5307C12.2406 9.88519 10.8853 11.2406 10.5308 12.9749C10.5239 13.0084 10.4762 13.0084 10.4694 12.9749C10.1149 11.2406 8.75948 9.88519 7.02512 9.5307C6.99171 9.52387 6.99171 9.47613 7.02512 9.4693C8.75948 9.11481 10.1149 7.75942 10.4694 6.02506Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1207 2.30967C15.2051 1.89678 15.795 1.89678 15.8794 2.30967C16.0658 3.22159 16.7785 3.93424 17.6904 4.12063C18.1033 4.20503 18.1033 4.79497 17.6904 4.87937C16.7785 5.06576 16.0658 5.77841 15.8794 6.69033C15.795 7.10322 15.2051 7.10322 15.1207 6.69033C14.9343 5.77841 14.2217 5.06576 13.3097 4.87937C12.8968 4.79497 12.8968 4.20503 13.3097 4.12063C14.2217 3.93424 14.9343 3.22159 15.1207 2.30967Z"
        fill="currentcolor"
      />
      <path
        d="M5.99988 7.00061H3.99988C2.89531 7.00061 1.99988 7.89604 1.99988 9.00061V20.0006C1.99988 21.1052 2.89531 22.0006 3.99988 22.0006H14.9999C16.1044 22.0006 16.9999 21.1052 16.9999 20.0006V9.00061"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9999 15.5006V13.5006L20.1916 9.85297C20.3875 9.62905 20.6705 9.50061 20.9681 9.50061C21.5379 9.50061 21.9999 9.96256 21.9999 10.5324V18.4688C21.9999 19.0387 21.5379 19.5006 20.9681 19.5006C20.6705 19.5006 20.3875 19.3722 20.1916 19.1483L16.9999 15.5006Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const GenerativePlugin = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      opacity="0.6"
      color="black"
      fill="none"
    >
      <circle
        cx="7"
        cy="8"
        r="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 3H4C2.89543 3 2 3.89543 2 5V20C2 21.1046 2.89543 22 4 22H19C20.1046 22 21 21.1046 21 20V11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 2L18.7579 2.69703C19.0961 3.61102 19.2652 4.06802 19.5986 4.40139C19.932 4.73477 20.389 4.90387 21.303 5.24208L22 5.5L21.303 5.75792C20.389 6.09613 19.932 6.26524 19.5986 6.59861C19.2652 6.93198 19.0961 7.38898 18.7579 8.30297L18.5 9L18.2421 8.30297C17.9039 7.38898 17.7348 6.93198 17.4014 6.59861C17.068 6.26524 16.611 6.09613 15.697 5.75792L15 5.5L15.697 5.24208C16.611 4.90387 17.068 4.73477 17.4014 4.40139C17.7348 4.06802 17.9039 3.61102 18.2421 2.69703L18.5 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 16.2714L16.3642 13.3207C15.571 12.8158 14.5148 12.9157 13.8406 13.5593L5 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const PremiumMediaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="black"
      strokeOpacity="0.6"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="c-kqncWw"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"></path>
      <path d="M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
    </svg>
  );
};

const UGCAdsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      className="c-iTWTMU"
    >
      <path
        d="M15 2.4578C14.053 2.16035 13.0452 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.9548 21.8396 9.94704 21.5422 9"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinecap="square"
      ></path>
      <path
        d="M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinecap="square"
      ></path>
      <path
        d="M5.49994 19.5001L6.06034 18.5194C6.95055 16.9616 8.60727 16.0001 10.4016 16.0001H13.5983C15.3926 16.0001 17.0493 16.9616 17.9395 18.5194L18.4999 19.5001"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinecap="square"
      ></path>
      <path
        d="M18.9735 2C18.6675 3.49732 17.4973 4.66745 16 4.97349V5.02651C17.4973 5.33255 18.6675 6.50268 18.9735 8H19.0265C19.3325 6.50268 20.5027 5.33255 22 5.02651V4.97349C20.5027 4.66745 19.3325 3.49732 19.0265 2H18.9735Z"
        stroke="black"
        strokeOpacity="0.6"
        strokeWidth="1.25"
        strokeLinecap="square"
      ></path>
    </svg>
  );
};

const BoltIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="c-iTWTMU"
    >
      <g clip-path="url(#clip0_858_2159)">
        <path
          d="M10.8337 2.5V8.33333H15.8337L9.16699 17.5V11.6667H4.16699L10.8337 2.5Z"
          stroke="black"
          strokeOpacity="0.6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_858_2159">
          <rect width="20" height="20" fill="black"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

const FeatureIcon = ({
  type,
  ...props
}: { type: string } & React.SVGProps<SVGSVGElement>) => {
  switch (type) {
    case 'generation_limits':
      return <GenerationLimitsIcon {...props} />;
    case 'credits_v2':
    case 'ai_credits_v2':
      return <AiCreditsIcon {...props} />;
    case 'express_clones':
      return <ExpressClonesIcon {...props} />;
    case 'generative_clips':
      return <GenerativeClipsIcon {...props} />;
    case 'deep_clones':
      return <DeepClonesIcon {...props} />;
    case 'exports':
      return <AdditionalFeaturesIcon {...props} />;
    case 'storage':
    case 'additional_features':
      return <ExportsIcon {...props} />;
    case 'content':
      return <ContentIcon {...props} />;
    case 'generative_plugin':
      return <GenerativePlugin {...props} />;
    case 'premium_media':
      return <PremiumMediaIcon {...props} />;
    case 'ugc_ads':
      return <UGCAdsIcon {...props} />;
    case 'ai_credits':
      return <BoltIcon {...props} />;
    default:
      return null;
  }
};

export default FeatureIcon;
